import { createWebHashHistory, createRouter } from 'vue-router'
import aiBoard from './ai-board'
import app from './app'

const routes = [
  app,
  {
    path: '/visit-path-detail',
    name: 'visit-path-detail-out',
    component: () => import('@/pages/details/visit-path-detail/index.vue'),
    meta: {
      title: '拜访轨迹',
      dynamicBgColor: '#F2F3F5'
    }
  }, // 拜访轨迹详情页 外层也放一个。销帮帮CRM内打开的是这个地址的。TODO  后面维护成一个
  {
    path: '/',
    component: () => import('@/components/router-entry/common/index.vue'),
    name: 'index',
    children: [
      {
        path: 'mobile-talk-assistant',
        name: 'mobile-talk-assistant',
        component: () => import('@/pages/MobileTalkAssistant/index.vue'),
        meta: {
          title: '客户分析师'
        }
      }
    ]
  },
  {
    path: '/appLogin',
    component: () => import('@/pages/AppLogin/index.vue'),
    name: 'appLoginIndex',
    meta: {
      title: '登录',
      dynamicBgColor: '#fff'
    }
  },
  {
    path: '/test-page',
    component: () => import('@/pages/TestPage/index.vue'),
    name: 'testPageIndex',
    meta: {
      title: '产品测试专用'
    }
  },
  {
    path: '/devlogin',
    component: () => import('@/pages/dev-login/index.vue'),
    name: 'devLoginIndex',
    meta: {
      title: '开发登录页，仅用于本地开发，目前自用'
    }
  },
  {
    path: '/book',
    name: 'book',
    component: () => import('@/components/router-entry/common/index.vue'),
    redirect: '/book/index',
    children: [
      {
        path: 'index',
        name: 'bookIndex',
        component: () => import('@/pages/Book/index.vue')
      }
    ]
  },
  {
    path: '/describe',
    name: 'describe',
    component: () => import('@/components/router-entry/common/index.vue'),
    redirect: '/describe/index',
    children: [
      {
        path: 'index',
        name: 'describeIndex',
        component: () => import('@/pages/Describe/index.vue')
      }
    ]
  },
  {
    path: '/iframe',
    name: 'iframe',
    component: () => import('@/pages/Iframe/index.vue'),
    meta: {
      unshowHeader: true
    }
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('@/components/router-entry/common/index.vue'),
    redirect: '/company/index',
    children: [
      {
        path: 'index',
        name: 'companyIndex',
        component: () => import('@/pages/Company/index.vue'),
        meta: {
          title: '切换公司'
        }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/router-entry/common/index.vue'),
    redirect: '/404/index',
    children: [
      {
        path: 'index',
        name: '404Index',
        component: () => import('@/pages/404/index.vue')
      }
    ]
  },
  {
    path: '/trial-apply',
    name: 'trialApply',
    component: () => import('@/pages/TrialApply/index.vue')
  },
  {
    path: '/sign-form',
    name: 'signForm',
    component: () => import('@/pages/SingForm/index.vue'),
    meta: {
      title: '试用登记'
    }
  },
  {
    path: '/download-page',
    name: 'downLoadPage',
    component: () => import('@/pages/SingForm/DownloadPage.vue'),
    meta: {
      title: 'app下载'
    }
  },
  {
    path: '/pro-visit-detail',
    name: 'proVisitDetail',
    component: () => import('@/pages/IframeDetail/index.vue'),
    meta: {
      title: '详情'
    }
  },
  aiBoard
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes
})
